import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { ChildSavingStepParams } from './types'
import { sustainabilitySchema } from './types'

export const sustainability = (params: ChildSavingStepParams) => {
  const schema = sustainabilitySchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_childSaving:steps.sustainability.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_child_saving_de.shape.configuration_parameters.shape.sustainability.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_childSaving:steps.sustainability.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('sustainability'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'quote',
    subFlow: SubFlow.ChildSaving,
  } as const satisfies AnyStepConfiguration
}
